<script>
export default {
    props: [
        "invalid",
        "value"
    ],
    watch: {
        invalid:{
            immediate: true,
            handler () {
                if (this.invalid && this.value) {
                    this.$emit("invalidInput", this.value);
                }
            }
        }
    },
    render() {
        return "";
    }
}
</script>
